(function () {
	'use strict';

	angular
        .module('app')
        .directive('drvSmsView', drvSmsView);

	drvSmsView.$inject = [];

	/**
     * @ngdoc directive
     * @name drvSmsView
     *
	 * @param {object} sms - SMS to be displayed. Refer to the sms.js for more details.
     * @param {bool} enableTagEditing - True to allow the user to edit tags. Default is false.
	 *
     * @description
     * Shows the supplied SMS in a view-only layout
     */
	function drvSmsView() {
		var directive = {
			restrict: 'E',
			scope: {},
			bindToController: {
			    sms: '<',
                enableTagEditing: '<?'
			},
			controllerAs: 'drvCtrl',
			templateUrl: 'app/sms/sms-view.tmpl.html',
			controller: drvSmsViewCtrl
		};

		drvSmsViewCtrl.$inject = ['SystemService', 'TagsService'];

		return directive;

		function drvSmsViewCtrl(SystemService, TagsService) {
			/* jshint validthis:true */
			var drvCtrl = this;

			Object.defineProperty(drvCtrl, 'date', {
				get: getFormattedDate
			});
			Object.defineProperty(drvCtrl, 'smsTo', {
				get: getSMSTo
			});

			activate();

			function activate() {
			    loadTags();
			}

			/**
			 * @returns {string} date formatted into a more readible form
			 */
			function getFormattedDate() {
				var result = '';

				if (angular.isDefined(drvCtrl.sms)) {
					result = SystemService.getFormattedDate(drvCtrl.sms.data.Date);
				}

				return result;
			}

			/**
			 * @returns {array} Returns the To recipient in an array which can be used with the contact selector control.
			 */
			function getSMSTo() {
				var result = [];

				if (!_.isNil(drvCtrl.sms) && !_.isNil(drvCtrl.sms.data) && !_.isNil(drvCtrl.sms.data.To)) {
				    if (angular.isArray(drvCtrl.sms.data.To)) {
				        result = angular.copy(drvCtrl.sms.data.To);
				    } else {
				        result = [drvCtrl.sms.data.To];
				    }
				}

				if (!angular.equals(getSMSTo.result, result)) {
					getSMSTo.result = result;
				}

				return getSMSTo.result;
			}

		    /**
             * Load tags into the drvCtrl.tags variable.
             *
             * @returns {promise} A promise that resolves once the tags are loaded, or an error occurred.
             */
			function loadTags() {
			    return TagsService.query({ tagUsage: 'SMS' })
                    .then(getTagsOk, getTagsError);

			    function getTagsOk(data) {
			        drvCtrl.tags = data.Tags;
			    }

			    function getTagsError(response) {
			        DialogService.error('Error fetching Tags', response);
			    }
			}
		}
	}
})();